// import { ColorTypes } from './toast.service';
import { ComponentType } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';
import { ToastComponent } from '../shared/util/toast/toast.component';
import { ToastSnack } from '../shared/util/toast/toast.models';

const defaultSnack: ToastSnack = {
  message: '',
  action: 'OK',
  type: 'warn',
  timer: 10000
};


@Injectable({
  providedIn: 'root'
})
export class ToastService {

  private snacks: ToastSnack[] = [];
  private snackRef: MatSnackBarRef<ToastComponent>;

  constructor(
    public sSnackbar: MatSnackBar
  ) { }


  error(message: string, options: ToastSnack = {}) {
    const _t: ToastSnack = {};
    Object.assign(_t, defaultSnack, options);
    _t.type = 'error';
    _t.message = message;

    this.snackStack(_t);
  }

  success(message: string, options: ToastSnack = {}) {
    const _t: ToastSnack = {};
    Object.assign(_t, defaultSnack, options);
    _t.type = 'info';
    _t.message = message;
    this.snackStack(_t);
  }

  info(message: string, options: ToastSnack = {}) {
    const _t: ToastSnack = {};
    Object.assign(_t, defaultSnack, options);
    _t.type = 'warn';
    _t.message = message;

    this.snackStack(_t);
  }

  snackbarFromComponent(component: ComponentType<unknown>, config?: MatSnackBarConfig<any>) {
    return this.sSnackbar.openFromComponent(component, config);
  }

  private snackStack(options: ToastSnack | string = {}) {
    const _t: ToastSnack = {};
    Object.assign(_t, defaultSnack);

    if (typeof (options) == 'string') {
      _t.message = options;
    } else {
      Object.assign(_t, options);
    }

    if (_t.timer < 800) {
      _t.timer = _t.timer * 1000;
    }

    const originalClick = _t.onAction;
    _t.onAction = () => {
      const idx = this.snacks.indexOf(_t);
      if (idx > -1) {
        this.snacks.splice(idx, 1);
      }
      this.closeIfEmpty();
      if (originalClick) {
        originalClick();
      }
    };

    if (_t.timer) {
      setTimeout(() => {
        const idx = this.snacks.indexOf(_t);
        if (idx > -1) {
          this.snacks.splice(idx, 1);
        }
        this.closeIfEmpty();
      }, _t.timer);
    }


    this.snacks.push(_t);
    if (this.snacks.length == 1) {
      this.snackRef = this.sSnackbar.openFromComponent(ToastComponent, {
        horizontalPosition: 'right',
        verticalPosition: 'top',
        panelClass: 'toast-staked',
        data: this.snacks
      });

    }


  }



  closeIfEmpty() {
    if (this.snacks.length == 0) {

      // delay to wait transition to be finished
      setTimeout(() => {
        this.closeAll();
      }, 600);
    }
  }

  closeAll() {
    this.snacks = [];
    this.snackRef.dismiss();
  }
}
